export enum MoovCustomerStatus {
  Pending = 'pending',
  InReview = 'in-review',
  Enabled = 'enabled',
  Disabled = 'disabled',
  Unverified = 'unverified',
}
